<script setup>
/* eslint-disable */
import { onMounted, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useFavouritesStore } from '@/stores/favourites';
import { useDatesStore } from '@/stores/dates';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useMarketsStore } from '@/stores/markets';

import FeaturedFixtureOverviewOdd from '@/components/esports/FeaturedFixtureOverviewOdd.vue';

const router = useRouter();
const favouritesStore = useFavouritesStore();
const datesStore = useDatesStore();
const liveSportsStore = useLiveSportsStore();
const marketsStore = useMarketsStore();

const props = defineProps({
	fixture: {
		required: true,
	},
	primary_overview_market: {
		required: true,
	},
});

const goToFixture = () => {
	router.push({ name: 'esports-fixturebook', params: { sport_id: props.fixture.sport_id, region_id: props.fixture.region_id, competition_id: props.fixture.competition_id, fixture_id: props.fixture.id } } )
}

const toggleFavourite = () => {
	favouritesStore.toggleFixture(props.fixture.id);
}

const primaryOverviewMarketOdds = computed(() => {
	if (!props.fixture.overview_markets.hasOwnProperty(props.primary_overview_market.slug)) return [];

	return props.fixture.overview_markets[props.primary_overview_market.slug];
});

</script>
<template>
	<div class="sidebar-bet-info">
		<div class="league-time">
			<span>{{ datesStore.preFixtureBookDate(fixture.start_datetime) }}</span>
			<span>{{ datesStore.preFixtureBookTime(fixture.start_datetime) }}</span>
		</div>
		<div class="live-info-outer">
			<div class="live-info-inner">

				<div class="star-ico" @click="toggleFavourite">
					<svg xmlns="http://www.w3.org/2000/svg" width="12" height="11.143" viewBox="0 0 12 11.143">
						<path :style="{fill: fixture.favourite ? '#63A246' : ''}" id="Icon_ionic-ios-star" data-name="Icon ionic-ios-star" d="M12.67,5.545H8.729l-1.2-3.573a.434.434,0,0,0-.814,0l-1.2,3.573H1.554a.43.43,0,0,0-.429.429.315.315,0,0,0,.008.072.412.412,0,0,0,.179.3L4.551,8.63,3.308,12.244a.43.43,0,0,0,.147.482.414.414,0,0,0,.241.1.525.525,0,0,0,.268-.1l3.161-2.253,3.161,2.253a.5.5,0,0,0,.268.1.385.385,0,0,0,.238-.1.425.425,0,0,0,.147-.482L9.7,8.63l3.212-2.3.078-.067a.449.449,0,0,0,.139-.287A.454.454,0,0,0,12.67,5.545Z" transform="translate(-1.125 -1.688)" fill="#4e545d"></path>
					</svg>
				</div>
				<div class="playing-team" @click="goToFixture">
					<div class="playing-team-inner team-one">
						<h6>{{ fixture.participants ? fixture.participants[0]:'' }}</h6>
					</div>
					<div class="playing-team-inner team-one" v-if="!liveSportsStore.hasOneParticipant(fixture.sport_id) && !fixture.outright">
						<h6>{{ fixture.participants ? fixture.participants[1] : '' }}</h6>
					</div>
				</div>

			</div>

			<div>
				<div class="betting_info">
					<FeaturedFixtureOverviewOdd
						:overview_market_header_name="primary_overview_market.odd_names[0]"
						:overview_odd="primaryOverviewMarketOdds[0]"
						:needs_indicator="marketsStore.overviewMarketNeedsIndicator(primary_overview_market)"
						:fixture_id="props.fixture.id"
					/>

					<FeaturedFixtureOverviewOdd v-if="primary_overview_market.three_way"
						:overview_market_header_name="primary_overview_market.odd_names[1]"
						:overview_odd="primaryOverviewMarketOdds[1]"
						:needs_indicator="marketsStore.overviewMarketNeedsIndicator(primary_overview_market)"
						:fixture_id="props.fixture.id"
					/>

					<FeaturedFixtureOverviewOdd
						:overview_market_header_name="primary_overview_market.odd_names[2]"
						:overview_odd="primary_overview_market.three_way ? primaryOverviewMarketOdds[2] : primaryOverviewMarketOdds[1]"
						:needs_indicator="marketsStore.overviewMarketNeedsIndicator(primary_overview_market)"
						:fixture_id="props.fixture.id"
					/>
				</div>
			</div>
		</div>

	</div>
</template>
<style scoped>
.star-ico {
	cursor: pointer;
}
</style>